import {
  ScheduleDTO,
  ScheduleDayDTO,
  SchedulePeriodDTO,
} from 'src/dtos/ScheduleDTO';

import { EnScheduleDay } from 'src/enums/EnScheduleDay';
import { EnScheduleTypes } from 'src/enums/EnScheduleTypes';

export class Schedule {
  public id!: number;
  public name!: string;
  public description!: string;
  public periods!: SchedulePeriod[];
  public type!: EnScheduleTypes;
  public linkedScheduleIds?: number[];
  public applicableClosingDaysSchedules: Schedule[];
  public applicableSpecialDaysSchedules: Schedule[];

  constructor(dto: ScheduleDTO) {
    this.id = dto.id;
    this.name = dto.name;
    this.description = dto.description;
    this.periods = dto.periods.map((period) => new SchedulePeriod(period));
    this.type = dto.type;

    if (dto.type !== EnScheduleTypes.OpeningHours) {
      this.linkedScheduleIds = dto.linkedTimePlanIds ?? [];
    }

    if (dto.applicableClosingAndSpecialOpeningHoursTimePlans) {
      this.applicableClosingDaysSchedules =
        dto.applicableClosingAndSpecialOpeningHoursTimePlans
          .filter(
            (scheduleDTO) => scheduleDTO.type === EnScheduleTypes.ClosingDays
          )
          .map((scheduleDTO) => new Schedule(scheduleDTO));

      this.applicableSpecialDaysSchedules =
        dto.applicableClosingAndSpecialOpeningHoursTimePlans
          .filter(
            (scheduleDTO) => scheduleDTO.type === EnScheduleTypes.SpecialDays
          )
          .map((scheduleDTO) => new Schedule(scheduleDTO));
    } else {
      this.applicableClosingDaysSchedules = [];
      this.applicableSpecialDaysSchedules = [];
    }
  }
}

export class SchedulePeriod {
  public id!: number;
  public days!: ScheduleDay[];
  public from!: Date;
  public to!: Date;

  constructor(dto: SchedulePeriodDTO) {
    this.id = dto.id;
    this.days = dto.days.map((day) => new ScheduleDay(day));
    this.from = new Date(dto.from);
    this.to = new Date(dto.to);
  }
}

export class ScheduleDay {
  public id!: number;
  public day!: EnScheduleDay;
  public allDay!: boolean;
  public from!: Date;
  public to!: Date;

  constructor(dto: ScheduleDayDTO) {
    this.id = dto.id;
    this.day = dto.day;
    this.allDay = dto.allDay;
    this.from = new Date(dto.from);
    this.to = new Date(dto.to);
  }
}
